/* eslint-disable */
// prettier-ignore
export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Home', route: { name: 'global-homePage' } },
      { title: 'Media Overview', route: { name: 'see-campaign-overview' } },
      { title: 'Media Awareness', route: { name: 'see-campaign-media-awareness' } },
      { title: 'Media Consideration', route: { name: 'see-campaign-media-consideration' } },
      { title: 'Media Conversion', route: { name: 'see-campaign-media-conversion' } },
      { title: 'Creative', route: { name: 'see-campaign-creative' } },
      { title: 'Media Reports', route: { name: 'see-smartReports-mediaReports' } },
      { title: 'Creative Hub', route: { name: 'manage-creativeHub' } },
      { title: 'Media Plan', route: { name: 'manage-plan' } },
      { title: 'Smart Optimization', route: { name: 'manage-smartOptimization' } },
      { title: 'Financial', route: { name: 'trust-transparency-financial' } },
      { title: 'Operational', route: { name: 'trust-transparency-operational' } },
      { title: 'Invoices', route: { name: 'trust-finance-invoice' } },
      { title: 'Notifications', route: { name: 'global-notificationsPage' } },
      { title: 'Users', route: { name: 'settings-users' } },
      { title: 'Campaign Labelling', route: { name: 'campaign-labelling-campaignPage' } },
    ],
  },
  }
/* eslint-enable */
